/**
 * Evminov US Catalog Products
 * Official product lineup of Evminov Spine Decompression Boards (Профілактори Євмінова)
 * and certified accessories.
 */

export const products = [
  // 1. Standard Solid Evminov Profilactor
  {
    id: 'evminov-standard',
    category: 'board',
    boardType: 'solid',
    name: 'Standard Solid Evminov Profilactor (1-Piece Non-Folding)',
    ukrName: 'Стандартний (цільний) Профілактор Євмінова',
    badge: 'Flagship Original • 1-Piece Solid',
    subtitle: 'Classic one-piece non-folding model. Continuous resonant Carpathian pine beam providing maximum monolithic rigidity for clinical and home rehabilitation.',
    keyFeature: 'Base monolithic model. Continuous multi-layer Carpathian pine beam providing maximum spring resonance for dedicated home or clinical wall-mount installation.',
    basePrice: 450, // Direct delivery from Ukraine ($450)
    fastPrice: 595, // Expedited 2-4 day delivery from Burbank, CA warehouse ($595)
    rating: 4.9,
    reviewsCount: 1420,
    specs: {
      construction: '1-Piece Solid Monolithic Beam',
      mobility: 'Permanent Home & Clinic Wall Mount',
      heightLimit: 'Up to 6\'4"',
      weightLimit: 'Up to 210 lbs',
      material: 'Multi-layer resonant Carpathian Pine (Light or Dark Pine)',
      weight: '23–25 lbs',
      inclineRange: '8° to 90° (and -25° reverse traction)',
      foldedDepth: '2.4" slim profile against wall',
    },
    includes: [
      'Patented Glisson Loop for cervical spine decompression (Value $65)',
      'Adjustable aircraft-grade alloy carriage with quick-lock pin',
      'Heavy-duty 16" wood stud wall mounting kit with 400+ lbs anchors',
      '30-Day Digital Spine Rehabilitation Video Program & clinical manual',
      '60-Day Risk-Free Home Trial & 10-Year Frame Warranty',
    ],
    finishes: ['Light Natural Pine', 'Dark Stained Pine'],
    image: '/images/authentic/evminov-board-profile.jpg',
    galleryImages: [
      { url: '/images/authentic/evminov-board-profile.jpg', label: 'Full Solid Board' },
      { url: '/images/authentic/hero-full-device-traction.jpg', label: 'In Clinical Action' },
      { url: '/images/accessories/standard-pine-board-assembly.png', label: 'Standard Board Assembly' },
      { url: '/images/authentic/evminov-board-head-mount.jpg', label: 'Carriage Head Mechanism' },
      { url: '/images/products/board-mounting-bracket.jpg', label: 'Wall Mount Assembly' },
      { url: '/images/products/board-natural-pine-finish.jpg', label: 'Light Pine Finish' },
      { url: '/images/products/board-dark-walnut-finish.jpg', label: 'Dark Pine Finish' }
    ],
    popular: true,
  },

  // 2. 2-Piece Folding Evminov Profilactor
  {
    id: 'evminov-folding-2part',
    category: 'board',
    boardType: 'folding-2',
    name: '2-Piece Folding Evminov Profilactor (Home Storage)',
    ukrName: 'Складаний (розбірний) Профілактор з 2-х частин',
    badge: 'Space Saver • 2-Piece Folding',
    subtitle: 'Optimized for compact apartment storage and quick room-to-room transport. Disassembles into two halves in 30 seconds with precision interlocking steel joints.',
    keyFeature: 'Optimized for compact home storage and easy transport. Disassembles in half in 30 seconds: stores conveniently under beds, in closets, or behind doors without losing tensile flex.',
    basePrice: 475,
    fastPrice: 615,
    rating: 4.9,
    reviewsCount: 680,
    specs: {
      construction: '2-Piece Precision Demountable Beam',
      mobility: 'Compact Closet & Under-Bed Storage',
      heightLimit: 'Up to 6\'4"',
      weightLimit: 'Up to 220 lbs',
      material: 'Selected resonant Carpathian Pine with interlocking steel reinforcement',
      weight: '25 lbs',
      inclineRange: '8° to 90°',
      foldedDepth: 'Stores flat under bed or in closet (~45" half length)',
    },
    includes: [
      'Patented Glisson Loop for cervical spine decompression (Value $65)',
      'Heavy-duty central steel interlocking connector with zero structural play',
      'Adjustable aircraft-grade alloy mobile carriage',
      'Quick-release wall mount anchor and safety pins',
      '60-Day Risk-Free Home Trial & 10-Year Warranty',
    ],
    finishes: ['Light Natural Pine', 'Dark Stained Pine'],
    image: '/images/accessories/standard-pine-board-assembly.png',
    galleryImages: [
      { url: '/images/accessories/standard-pine-board-assembly.png', label: '2-Piece Assembly' },
      { url: '/images/products/board-perspective-view.jpg', label: 'Perspective View' },
      { url: '/images/products/board-carriage-locking-pin.jpg', label: 'Interlocking Pin' },
      { url: '/images/products/board-natural-pine-finish.jpg', label: 'Light Pine Finish' },
      { url: '/images/products/board-dark-walnut-finish.jpg', label: 'Dark Pine Finish' }
    ],
    popular: false,
  },

  // 3. 3-Piece Folding Evminov Profilactor
  {
    id: 'evminov-folding-3part',
    category: 'board',
    boardType: 'folding-3',
    name: '3-Piece Folding Evminov Profilactor (Ultra-Compact Travel)',
    ukrName: 'Складаний (розбірний) Профілактор з 3-х частин',
    badge: 'Car Trunk & Airline Ready • 3-Piece Travel',
    subtitle: 'The most compact mobile board in the Evminov family. Engineered to pack down effortlessly into any car trunk, SUV cargo bay, or aircraft luggage travel bag.',
    keyFeature: 'Ultra-compact mobile design (~31" folded segments). Packs effortlessly into car trunks, SUVs, or luggage bags for air travel. Ideal for frequent travelers, vacation homes, and mobile physical therapists.',
    basePrice: 495,
    fastPrice: 635,
    rating: 4.9,
    reviewsCount: 890,
    specs: {
      construction: '3-Piece Ultra-Compact Demountable Beam',
      mobility: 'Fits Car Trunks & Airline Travel Bags',
      heightLimit: 'Up to 6\'4"',
      weightLimit: 'Up to 220 lbs',
      material: 'Resonant Carpathian Pine with dual aircraft alloy couplers',
      weight: '26 lbs',
      inclineRange: '8° to 90°',
      foldedDepth: 'Ultra-compact ~31" segment length',
    },
    includes: [
      'Patented Glisson Loop for cervical spine decompression (Value $65)',
      'Dual precision steel interlocking joints with rapid tool-free assembly',
      'Over-the-door travel strap and universal wall mounting kit',
      'Padded travel carry case compatible with car trunks and airline check-in',
      '60-Day Risk-Free Home Trial & 10-Year Warranty',
    ],
    finishes: ['Light Natural Pine', 'Dark Stained Pine'],
    image: '/images/accessories/folding-board-3-sections.png',
    galleryImages: [
      { url: '/images/accessories/folding-board-3-sections.png', label: '3-Piece Folded' },
      { url: '/images/products/board-travel-bag-carrying.jpg', label: 'Travel Case & Trunk' },
      { url: '/images/products/board-door-mount-setup.jpg', label: 'Over-The-Door Setup' },
      { url: '/images/products/board-carriage-locking-pin.jpg', label: 'Steel Connector Pins' },
      { url: '/images/products/board-natural-pine-finish.jpg', label: 'Light Pine' },
      { url: '/images/products/board-dark-walnut-finish.jpg', label: 'Dark Pine' }
    ],
    popular: true,
  },

  // 4. Wide Panel Evminov Profilactor
  {
    id: 'evminov-wide',
    category: 'board',
    boardType: 'wide',
    name: 'Wide Panel Evminov Profilactor (Heavy-Duty & Athletes)',
    ukrName: 'Профілактор з широкою панеллю (Heavy-Duty)',
    badge: 'Heavy-Duty • Broad Build (Up to 330 lbs)',
    subtitle: 'Reinforced heavy-duty board engineered specifically for individuals of larger build, broader shoulders, and athletes. Also available in folding configuration.',
    keyFeature: 'Engineered for larger body builds, broad shoulders, and athletes (rated up to 330 lbs). Features a 30% wider timber panel and heavy-duty reinforced carriage.',
    basePrice: 500,
    fastPrice: 635,
    rating: 4.9,
    reviewsCount: 520,
    specs: {
      construction: 'Extra-Wide Timber Panel (Solid or Demountable)',
      mobility: 'Heavy-Duty Wall Mount or Stand (Rated up to 330 lbs)',
      heightLimit: 'Up to 6\'9"',
      weightLimit: 'Up to 330 lbs',
      material: 'Reinforced high-tensile multi-layer Carpathian pine core',
      weight: '30 lbs',
      inclineRange: '8° to 90°',
      foldedDepth: '2.8" heavy-duty wall profile',
    },
    includes: [
      'Reinforced Glisson loop with extra ergonomic cervical padding',
      'Extra-wide heavy-duty carriage with double safety lock pins',
      'High-capacity 16" stud mounting bracket & heavy-duty masonry anchors',
      'Athletic Spine Restoration Protocol for Deadlifts, Squats & Heavy Training',
      '60-Day Risk-Free Home Trial & 10-Year Frame Warranty',
    ],
    finishes: ['Light Natural Pine', 'Dark Stained Pine', 'Gym Stealth Black'],
    image: '/images/products/board-studio-incline.jpg',
    galleryImages: [
      { url: '/images/products/board-studio-incline.jpg', label: 'Wide Board Platform' },
      { url: '/images/accessories/wide-board-heavy-duty.png', label: 'Wide Dimensions Spec' },
      { url: '/images/products/board-carriage-locking-pin.jpg', label: 'Heavy-Duty Safety Pin' },
      { url: '/images/products/board-studio-woodgrain.jpg', label: 'Reinforced Core Grain' },
      { url: '/images/products/board-wall-mount-hardware.jpg', label: 'Heavy-Duty Hardware' }
    ],
    popular: false,
  },

  // 5. Select Alder Wood Evminov Profilactor
  {
    id: 'evminov-alder',
    category: 'board',
    boardType: 'alder',
    name: 'Select Alder Wood Evminov Profilactor (Limited Edition)',
    ukrName: 'Профілактор з вільхи (Преміум Вільха)',
    badge: 'Limited Edition • Lightweight Alder Wood',
    subtitle: 'Exclusive limited version handcrafted from cured Ukrainian Alder wood. Noticeably lighter in weight than pine with a richer, darker warm-amber hue.',
    keyFeature: 'Limited edition cured Alder wood. Approximately 15% lighter than pine for effortless angle adjustment, featuring a silky grain and distinguished warm amber hue.',
    basePrice: 525,
    fastPrice: 665,
    rating: 5.0,
    reviewsCount: 340,
    specs: {
      construction: 'Solid Artisan Cured Alder Wood',
      mobility: 'Lightweight Handling & Easy Angle Adjustment',
      heightLimit: 'Up to 6\'4"',
      weightLimit: 'Up to 220 lbs',
      material: 'Rare cured Ukrainian Alder wood — naturally lightweight & silky grain',
      weight: '19–21 lbs • ~15% lighter than pine',
      inclineRange: '8° to 90° (and -25° reverse traction)',
      foldedDepth: '2.4" slim wall profile',
    },
    includes: [
      'Patented Glisson Loop with matching amber leatherette trim',
      'Artisan polished smooth alloy carriage mechanism',
      'Precision stud wall mounting kit with decorative brass hardware caps',
      'VIP Concierge Onboarding & 1-on-1 Certified Kinesiotherapist Video Session',
      '60-Day Risk-Free Home Trial & 10-Year Craftsmanship Warranty',
    ],
    finishes: ['Natural Ukrainian Alder (Warm Amber)', 'Royal Cognac Alder (Dark Hue)'],
    image: '/images/products/board-studio-woodgrain.jpg',
    galleryImages: [
      { url: '/images/products/board-studio-woodgrain.jpg', label: 'Silky Alder Grain' },
      { url: '/images/products/board-dark-walnut-finish.jpg', label: 'Alder Amber Finish' },
      { url: '/images/authentic/evminov-board-profile.jpg', label: 'Artisan Profile' },
      { url: '/images/authentic/hero-reverse-decompression.jpg', label: 'Lightweight Handling' },
      { url: '/images/authentic/evminov-pine-wood-detail.jpg', label: 'Handcrafted Timber Detail' }
    ],
    popular: false,
  },

  // 6. Demountable Free-Standing Ladder Stand
  {
    id: 'evminov-stand',
    category: 'accessory',
    name: 'Demountable Free-Standing Ladder Stand',
    ukrName: 'Демонтована стійка-драбина для Профілактора',
    badge: 'For Renters • No Wall Holes Needed',
    subtitle: 'Sturdy freestanding timber ladder stand engineered for apartments and rental homes. Enables full 8°–90° incline adjustment without drilling into drywall or wood studs.',
    keyFeature: 'Freestanding timber ladder stand for apartments and rental homes. Enables full incline angle adjustments without drilling into walls, completely protecting your security deposit.',
    basePrice: 275,
    fastPrice: 345,
    rating: 4.9,
    reviewsCount: 220,
    specs: {
      construction: 'Freestanding Timber Ladder',
      mobility: 'Tool-Free 3-Minute Disassembly',
      heightLimit: 'Compatible with all Evminov boards',
      weightLimit: 'Rated for up to 350 lbs user weight',
      material: 'Solid kiln-dried beech wood & powder-coated steel',
      weight: '24 lbs',
      inclineRange: 'Full 8° to 90° incline range on ladder rungs',
      foldedDepth: 'Takes less than 3.5 sq ft of floor area',
    },
    includes: [
      'Tool-free locking hardware & safety pins',
      'Floor-protecting non-scratch rubberized footing pads',
      'Instructional assembly manual and video QR code',
    ],
    finishes: ['Matching Nordic Pine', 'Natural Beech'],
    image: '/images/accessories/renter-stand-setup.jpg',
    galleryImages: [
      { url: '/images/accessories/renter-stand-setup.jpg', label: 'Assembled Stand' },
      { url: '/images/authentic/evminov-board-profile.jpg', label: 'Angle Profile' }
    ],
    popular: false,
  },
];

